import { useState } from "react";
import DistributorNavbar from "./DistributorComp/DistributorNavbar";
import DataTable from "react-data-table-component"; 
import DistributorReportNavbar from "./DistributorComp/DistributorReportNavbar";

function TransactionReport() {
  const [filterText, setFilterText] = useState("");

  // Dummy data for transactions
  const transactions = [
    {
      id: 1,
      customerName: "Amit Sharma",
      bookingDate: "2024-02-10",
      from: "Delhi",
      to: "Mumbai",
      travelingDate: "2024-02-20",
      status: "Completed",
      bookedBy: "Agent 101",
      commission: "₹500",
    },
    {
      id: 2,
      customerName: "Priya Singh",
      bookingDate: "2024-02-12",
      from: "Bangalore",
      to: "Goa",
      travelingDate: "2024-02-25",
      status: "Pending",
      bookedBy: "Agent 102",
      commission: "₹300",
    },
    {
      id: 3,
      customerName: "Rohit Verma",
      bookingDate: "2024-02-15",
      from: "Kolkata",
      to: "Chennai",
      travelingDate: "2024-02-28",
      status: "Cancelled",
      bookedBy: "Agent 103",
      commission: "₹0",
    },
    {
      id: 4,
      customerName: "Neha Kapoor",
      bookingDate: "2024-02-18",
      from: "Hyderabad",
      to: "Pune",
      travelingDate: "2024-03-05",
      status: "Completed",
      bookedBy: "Agent 104",
      commission: "₹600",
    },
  ];

  // Function to render status badge
  const renderStatusBadge = (status) => {
    let badgeClass = "status-badge bg-secondary";
    if (status === "Completed") badgeClass = "status-badge bg-success";
    else if (status === "Pending") badgeClass = "status-badge bg-warning text-dark";
    else if (status === "Cancelled") badgeClass = "status-badge bg-danger";

    return <span className={badgeClass}>{status}</span>;
  };

  // Columns for the DataTable
  const columns = [
    { name: "Sr. No.", selector: (row, index) => index + 1, sortable: false, width: "80px" },
    { name: "Customer Name", selector: (row) => row.customerName, sortable: true },
    { name: "Booking Date", selector: (row) => row.bookingDate, sortable: true },
    { name: "From", selector: (row) => row.from, sortable: true },
    { name: "To", selector: (row) => row.to, sortable: true },
    { name: "Traveling Date", selector: (row) => row.travelingDate, sortable: true },
    { 
      name: "Status", 
      selector: (row) => row.status, 
      sortable: true, 
      cell: (row) => renderStatusBadge(row.status),
      width: "120px"
    },
    { name: "Booked By Agent", selector: (row) => row.bookedBy, sortable: true },
    { name: "Commission", selector: (row) => row.commission, sortable: true },
  ];

  // Filter transactions based on search input
  const filteredTransactions = transactions.filter(
    (transaction) =>
      transaction.customerName.toLowerCase().includes(filterText.toLowerCase()) ||
      transaction.bookingDate.includes(filterText) ||
      transaction.bookedBy.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <>
      <DistributorNavbar />
      <div className="bgagent transaction-container">

      <div className="container-fluid">



        <div>
            <DistributorReportNavbar/>
        </div>
      <div className="crdmain">

      <div className="transaction-card">



          <h2 className="title text-start">All Transactions</h2>

          <input
            type="text"
            className="search-box"
            placeholder="Search transactions..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
          />

          {/* <DataTable
            columns={columns}
            data={filteredTransactions}
            pagination
            highlightOnHover
            striped
            noDataComponent="No transactions found"
            className="transaction-table"
          /> */}
        </div>


      </div>
      </div>


        
      </div>
    </>
  );
}

export default TransactionReport;
